/**
 * SANDBOX environment.
 *
 * Order Manager Sandbox UI hosted at: https://omsandbox.ringoffice.com
 * Backend talks to OneGate DEV (https://onegate-dev.ringoffice.com).
 *
 * Note on the double `/api/api`: the existing nginx in front of the OM
 * sandbox API strips the FIRST `/api/` and the express router on the
 * backend is mounted at `/api`, so the path resolves correctly. Keep this
 * shape unless you also update the nginx proxy_pass.
 */
export const environment = {
  envName: 'sandbox' as 'local' | 'sandbox' | 'production',
  production: false,

  apiUrl: 'https://omsandbox.ringoffice.com/api/api',
  apiUrlSlash: 'https://omsandbox.ringoffice.com/api/api/',

  oneGateLabel: 'OneGate Dev (https://onegate-dev.ringoffice.com)',

  // Frontend URL of OneGate for the SSO popup. The popup opens at
  // ${oneGateUrl}/sso?portal=<ssoPortalAudience>&return=…&popup=1
  // and postMessages the SSO token back. Origin must match this URL.
  oneGateUrl: 'https://onegate-dev.ringoffice.com',
  ssoPortalAudience: 'order-manager',

  appVersion: '1.0.0-sandbox',
};
